<template>
  <div class="container">
    <div v-if="!orderbool">
      <h3 class="green subtitle">
        {{ $translate('subtitle_form_model_inserts') }}
      </h3>
      <hr />
    </div>
    <div v-for="section in sections" :key="section.key">
      <h4 class="green subtitle">{{ $translate(section.key) | capitalize }}</h4>
      <div v-if="!singleSide" class="columns">
        <div v-for="side in sides" :key="`${section.key}-head-${side}`" class="column is-6">
          <h5 class="subtitle">
            {{ (side === 'sx' ? $translate('left_foot') : $translate('right_foot')) | uppercase }}
          </h5>
        </div>
      </div>
      <template v-for="n in section.slots">
        <div :key="`${section.key}-row-${n}`" class="columns">
          <div
            v-for="side in renderSides"
            :key="`${section.key}-${side}-${n}`"
            :class="singleSide ? 'column' : 'column is-6'"
          >
            <div
              v-for="(slot, si) in slotItems(section, side, n)"
              :key="`${section.key}-${side}-${n}-${si}`"
              class="columns"
            >
              <div class="column is-8">
                <b-field :label="`${$translate('insert')} ${n}` | capitalize">
                  <b-select
                    v-model="slot.material"
                    :name="`material-${section.key}_${side}-${n - 1}${suffix}`"
                    :disabled="disabledbool || sideDisabled(side)"
                    expanded
                    @input="onChangeMaterial(slot)"
                  >
                    <option :value="null">{{ $translate('none') | capitalize }}</option>
                    <option
                      v-for="mat in materialsFor(section.key)"
                      :key="mat.id"
                      :value="mat.id"
                      :label="$translateMaterial(mat)"
                    >
                      {{ $translateMaterial(mat) }}
                    </option>
                  </b-select>
                </b-field>
                <b-field
                  v-show="slot.material != null"
                  :label="$translate('insert_variant') | capitalize"
                  :type="{ 'is-danger': errors.has(`variant-${section.key}_${side}-${n - 1}${suffix}`) }"
                  :message="errors.first(`variant-${section.key}_${side}-${n - 1}${suffix}`)"
                >
                  <b-select
                    v-model="slot.variant"
                    v-validate="slot.material ? 'required' : ''"
                    :name="`variant-${section.key}_${side}-${n - 1}${suffix}`"
                    :disabled="disabledbool || sideDisabled(side)"
                    :placeholder="$translate('placeholder_select')"
                    expanded
                  >
                    <template v-for="mat in materialsFor(section.key)">
                      <template v-if="mat.id === slot.material">
                        <option v-for="matVar in mat.variants" :key="matVar.id" :value="matVar.id">
                          {{ $translateMaterialVariant(matVar) }}
                        </option>
                      </template>
                    </template>
                  </b-select>
                </b-field>
                <b-field
                  v-show="slot.variant != null"
                  :label="$translate('thickness') | capitalize"
                  :type="{ 'is-danger': errors.has(`thickness-${section.key}_${side}-${n - 1}${suffix}`) }"
                  :message="errors.first(`thickness-${section.key}_${side}-${n - 1}${suffix}`)"
                >
                  <b-numberinput
                    v-model="slot.thickness"
                    v-validate="slot.variant ? 'required' : ''"
                    :name="`thickness-${section.key}_${side}-${n - 1}${suffix}`"
                    :controls="false"
                    :min="0"
                    :use-html5-validation="false"
                    :disabled="disabledbool || sideDisabled(side)"
                    :placeholder="$translate('placeholder_thickness_mm')"
                  ></b-numberinput>
                </b-field>
              </div>
              <div class="column is-4 has-text-centered image-cell">
                <img v-if="imageFor(slot)" :src="imageFor(slot)" style="max-width: 100%; max-height: 120px;" />
              </div>
            </div>
          </div>
        </div>
        <hr v-if="n < section.slots" :key="`${section.key}-hr-${n}`" />
      </template>
      <hr class="green" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Inserts',
  inject: ['$validator'],
  props: ['orderbool', 'mod', 'availableInserts', 'disabledbool', 'pair', 'nameSuffix', 'singleSide'],
  computed: {
    suffix() {
      return this.nameSuffix ? this.nameSuffix : ''
    },
    renderSides() {
      return this.singleSide ? [this.singleSide] : this.sides
    },
  },
  data() {
    return {
      sections: [
        { key: 'avampiede', slots: 2 },
        { key: 'mesopiede', slots: 2 },
        { key: 'retropiede', slots: 2 },
        { key: 'piani_inclinati', slots: 1 },
      ],
      sides: ['sx', 'dx'],
    }
  },
  watch: {
    mod() {
      this.ensureStructure()
    },
  },
  created() {
    this.ensureStructure()
  },
  methods: {
    sideDisabled(side) {
      return side === 'sx' ? this.pair === 'right' : this.pair === 'left'
    },
    ensureStructure() {
      if (!this.mod) return
      if (!this.mod.inserts) {
        this.$set(this.mod, 'inserts', {})
      }
      this.sections.forEach(section => {
        const legacy = Array.isArray(this.mod.inserts[section.key]) ? this.mod.inserts[section.key] : null
        this.sides.forEach(side => {
          const key = `${section.key}_${side}`
          if (!Array.isArray(this.mod.inserts[key])) {
            this.$set(this.mod.inserts, key, [])
          }
          const slots = this.mod.inserts[key]
          for (let i = 0; i < section.slots; i++) {
            if (!slots[i]) {
              const seed = legacy && legacy[i] ? legacy[i] : null
              this.$set(slots, i, {
                material: seed && seed.material !== undefined ? seed.material : null,
                variant: seed && seed.variant !== undefined ? seed.variant : null,
                thickness: seed && seed.thickness !== undefined ? seed.thickness : null,
              })
            } else {
              if (slots[i].material === undefined) this.$set(slots[i], 'material', null)
              if (slots[i].variant === undefined) this.$set(slots[i], 'variant', null)
              if (slots[i].thickness === undefined) this.$set(slots[i], 'thickness', null)
            }
          }
          if (slots.length > section.slots) {
            slots.splice(section.slots)
          }
        })
        if (legacy) {
          this.$delete(this.mod.inserts, section.key)
        }
      })
    },
    slotItems(section, side, n) {
      const slots = this.mod && this.mod.inserts ? this.mod.inserts[`${section.key}_${side}`] : null
      return slots && slots[n - 1] ? [slots[n - 1]] : []
    },
    materialsFor(sectionKey) {
      return (this.availableInserts || []).filter(mat => mat.insertFilter === sectionKey)
    },
    imageFor(slot) {
      if (slot.material == null || slot.variant == null) return ''
      const mat = (this.availableInserts || []).find(m => m.id === slot.material)
      if (mat && mat.variants) {
        const variant = mat.variants.find(v => v.id === slot.variant)
        return variant ? variant.image : ''
      }
      return ''
    },
    onChangeMaterial(slot) {
      slot.variant = null
      slot.thickness = null
    },
  },
}
</script>
<style scoped>
.container >>> .select,
.container >>> .select select {
  width: 100%;
}
.image-cell {
  padding-top: 2.75em;
}
</style>
